export const CREATE_PASS_FORM_TYPE_BOARDING_PASS = "boardingPass";
export const CREATE_PASS_FORM_TYPE_COUPON = "coupon";
export const CREATE_PASS_FORM_TYPE_EVENT_TICKET = "eventTicket";
export const CREATE_PASS_FORM_TYPE_GENERIC = "generic";
export const CREATE_PASS_FORM_TYPE_STORE_CARD = "storeCard";
